<script>
import { _ } from 'svelte-intl';
import firebase from 'firebase/app';
export let date;

$: day = date
  ? date.substr(8,2)
  : '';
$: month = date
  ? $_(`date.months.${date.substr(5,2)}`)
  : '';
$: lastDayDigit = (day === '11' || day === '12') ? day : date.substr(9,1);
$: daySuffix = $_(`date.daySuffix.${lastDayDigit}`);
$: dateString = $_('date.formatNoYear', { day, daySuffix, month, year: '' })

let expanded = {
  whyOMDays: !window.matchMedia("(max-width: 768px)").matches,
  whyPlace: false,
  parkings: false,
  location: false
}


function toggleItem(item) {
  expanded[item] = !expanded[item];
  firebase.analytics().logEvent('information_toggle', { item, state: expanded[item] });
}
</script>

<div class="expand" class:active={expanded.whyOMDays}>
  <div class="expand__trigger" on:click={() => toggleItem('whyOMDays')}>
    <h3>{$_('information.whyDays.title')}</h3>
  </div>
  <div class="expand__content">
    {@html $_('information.whyDays.description', { dateString })}
  </div>
</div>

<div class="expand" class:active={expanded.whyPlace}>
  <div class="expand__trigger" on:click={() => toggleItem('whyPlace')}>
    <h3>{$_('information.whyPlace.title')}</h3>
  </div>
  <div class="expand__content">
    {@html $_('information.whyPlace.description')}
  </div>
</div>

<div class="expand" class:active={expanded.parkings}>
  <div class="expand__trigger" on:click={() => toggleItem('parkings')}>
    <h3>{$_('information.parkings.title')}</h3>
  </div>
  <div class="expand__content">
    <ul>
      <li>{@html $_('information.parkings.addresses.0')}</li>
      <li>{@html $_('information.parkings.addresses.1')}</li>
      <li>{@html $_('information.parkings.addresses.2')}</li>
      <li>{@html $_('information.parkings.addresses.3')}</li>
    </ul>
  </div>
</div>

<div class="expand" class:active={expanded.location}>
  <div class="expand__trigger" on:click={() => toggleItem('location')}>
    <h3>{$_('information.location.title')}</h3>
  </div>
  <div class="expand__content">
    {#if expanded.location}
      <iframe title="Address" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1631.4143643943835!2d5.9829422239243195!3d49.491980367286274!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x479534e3992f3c37%3A0x835739be3be03b21!2s108%20Boulevard%20John%20Fitzgerald%20Kennedy%2C%204040%20Esch-sur-Alzette!5e0!3m2!1sfr!2slu!4v1580201369175!5m2!1sfr!2slu" width="100%" height="300" frameborder="0" style="border:0;" allowfullscreen=""></iframe>
    {/if}
  </div>
</div>

<style>
/* h2 {
  margin-top: 0;
  margin-bottom: 4rem;
  padding-left: 1rem;
}
 */

.expand {
  overflow: hidden;
  padding: 1rem;
}

.expand__trigger {
  position: relative;
  cursor: pointer;
}

.expand__trigger:after {
  background-image: url('/images/arrow.svg');
  background-size: 14px;
  background-repeat: no-repeat;
  position: absolute;
  width: 16px;
  height: 16px;
  content: "";
  right: 0;
  top: 0.6rem;
  transition: 0.2s;
}

.expand.active .expand__trigger:after {
  transform: rotate(180deg);
  transition: 0.2s;
}

.expand__content {
  max-height: 0;
  transition: 0.3s;
  border-bottom: 1px solid #dddddd;
  overflow: hidden;
}

h3 {
  margin: 0 2rem 0 0;
  font-weight: 500;
  font-size: 2rem;
  padding-bottom: 2.5rem;
}

.expand.active .expand__content {
  max-height: 800px;
  transition: 0.3s;
}

.expand__content :global(p) {
  font-size: 1.8rem;
  line-height: 1.5;
}

ul {
  padding-left: 2rem;
  margin-top: 2rem;
}

ul li {
  margin-bottom: 2.5rem;
}
</style>